import { Box } from '@mui/material';
import { ReactSVG } from 'react-svg';

// ----------------------------------------------------------------------

export default function Icon({ name, width = 20, height = 20, fill, color = '#000', sx = {} }) {
  if (!name) return null;

  return (
    <Box
      sx={{
        '& svg': { width, height, ...(fill && { '& path': { fill } }), ...(color && { '& path': { stroke: color } }) },
        ...sx,
      }}
    >
      <ReactSVG src={`/icons/${name}.svg`} style={{ width: width + 2, height: height + 2, margin: 'auto' }} />
    </Box>
  );
}
